import { getBaseReducer } from 'utils';
import { spottingGroupModel as model } from 'models/spottingGroup';
import actions from './actions';

const initState = {
  ...(getBaseReducer(model)),
  entityType: 'spottingGroups',
  existingNames: [],
};

export default function spottingGroupReducer(state = initState, action) {
  switch (action.type) {
    case actions.CLEAR_SPOTTINGGROUPS:
      return {
        ...state,
        data: [],
        selectedItem: {},
        init: false,
      };
    case actions.SORT_SPOTTINGGROUPS:
      return {
        ...state,
        sort: action.sort,
      };
    case actions.FETCH_SPOTTINGGROUPS_SUCCESS:
      return {
        ...state,
        data: action.data,
        existingNames: action.existingNames,
        init: true,
      };
    case actions.SELECT_SPOTTINGGROUP:
      return {
        ...state,
        selectedItem: action.selectedItem,
      };
    case actions.ADD_SPOTTINGGROUP_SUCCESS:
      return {
        ...state,
        data: [
          action.selectedItem,
          ...state.data,
        ],
        selectedItem: action.selectedItem,
        view: false,
      };
    case actions.EDIT_SPOTTINGGROUP_SUCCESS:
      return {
        ...state,
        selectedItem: action.selectedItem,
        view: false,
      };
    case actions.DELETE__SPOTTINGGROUP:
      return {
        ...state,
        data: action.data.filter((x) => x),
        selectedId: action.selectedId,
      };
    case actions.CHANGE_SPOTTINGGROUP_VIEW:
      return {
        ...state,
        selectedItem: action.selectedItem || {},
        view: !state.view,
      };
    default:
      return state;
  }
}
